import { useState, useEffect, useCallback } from 'react';
import API, { getImageUrl } from '../utils/api';

const HeroSlider = ({ page, pageName }) => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get(`/banners/${page}`).then(r => {
      setBanners(r.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [page]);

  const next = useCallback(() => setCurrent(c => (c + 1) % banners.length), [banners.length]);
  const prev = () => setCurrent(c => (c - 1 + banners.length) % banners.length);

  useEffect(() => {
    if (banners.length <= 1) return;
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [banners.length, next]);

  if (loading) return (
    <div className="hero-placeholder">
      <div className="spinner" style={{ borderTopColor: 'rgba(201,168,76,0.8)' }} />
    </div>
  );

  if (!banners.length) return (
    <div className="hero-placeholder" style={{ paddingTop: 80 }}>
      <div style={{ maxWidth: 600, padding: '0 20px' }}>
        <div style={{ 
          fontSize: '0.78rem', letterSpacing: '0.15em', textTransform: 'uppercase',
          color: 'rgba(201,168,76,0.8)', marginBottom: 20, display: 'flex', 
          alignItems: 'center', gap: 12 
        }}>
          <span style={{ display: 'inline-block', width: 40, height: 1, background: 'rgba(201,168,76,0.5)' }} />
          Welcome
        </div>
        <h1 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2.5rem, 6vw, 5rem)', color: 'white', marginBottom: 20 }}>
          The Village <br />Investors
        </h1>
        <p style={{ opacity: 0.7, fontSize: '1.1rem', maxWidth: 500 }}>
          Investing in yourself, your community, and your future.
        </p>
      </div>
    </div>
  );

  return (
    <section className="hero-slider">
      {banners.map((banner, i) => (
        <div key={banner._id} className={`hero-slide ${i === current ? 'active' : ''}`}>
          <img src={getImageUrl(banner.image)} alt={banner.title} />
          <div className="hero-overlay" />
          <div className="hero-content">
            <div className="hero-tag">{pageName}</div>
            <h1 className="hero-title">{banner.title}</h1>
            {banner.subtitle && <p className="hero-subtitle">{banner.subtitle}</p>}
            {banner.ctaText && (
              <a 
                href={banner.ctaLink || '#'} 
                className="hero-cta"
                target={banner.ctaLink?.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
              >
                {banner.ctaText} <span>→</span>
              </a>
            )}
          </div>
        </div>
      ))}

      {banners.length > 1 && (
        <>
          <div className="hero-controls">
            {banners.map((_, i) => (
              <button 
                key={i} 
                className={`hero-dot ${i === current ? 'active' : ''}`}
                onClick={() => setCurrent(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
          <div className="hero-arrows">
            <button className="hero-arrow" onClick={prev} aria-label="Previous slide">‹</button>
            <button className="hero-arrow" onClick={next} aria-label="Next slide">›</button>
          </div>
        </>
      )}
    </section>
  );
};

export default HeroSlider;
